import styled from '@emotion/styled';
import { Box, Card, Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const StyledBox = styled(Box)`
  display: grid;
  grid-template-columns: 256px 1fr;
  align-items: stretch;
  width: 100%;
  padding: 0;
  max-height: 264px;

  @media (max-width: 900px) {
    max-height: 500px;
    height: 350px;
    max-width: 225px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DateTypography = styled(Typography)`
  font-size: 12px;
  line-height: 130%;
  font-weight: 500;
  color: ${customPalette.accent.main};
  margin: 0 0 12px 0;
`;

export const TitleTypography = styled(Typography)`
  font-size: 18px;
  line-height: 120%;
  font-weight: 700;
  letter-spacing: 0.15px;
  color: ${customPalette.accent.main};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 700px;

  @media (min-width: 1201px) and (max-width: 1480px) {
    max-width: 200px !important;
  }

  @media (max-width: 1450px) {
    max-width: 550px;
  }

  @media (max-width: 1200px) {
    max-width: 500px;
  }

  @media (max-width: 900px) {
    max-width: 200px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  @media (max-width: 660px) {
    max-width: 200px;
  }
`;

export const SummaryAndLinkContainer = styled.div`
  margin: 12px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${customPalette.accent.main};
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  justify-content: left;
  align-items: self-start;
  max-width: 700px;

  @media (max-width: 1650px) {
    max-width: 550px;
  }

  @media (min-width: 1201px) and (max-width: 1245px) {
    max-width: 400px;
  }

  @media (max-width: 1200px) {
    max-width: 500px;
  }

  @media (max-width: 900px) {
    max-width: 200px;
  }

  @media (max-width: 660px) {
    max-width: 200px;
  }

  .description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    @media (max-width: 900px) {
      -webkit-line-clamp: 4;
      text-overflow: ellipsis;
    }
  }

  .read-more-container {
    margin-top: 8px;
    text-align: left;
  }

  & a {
    text-decoration: underline;
    color: ${customPalette.accent.main};
  }
`;

export const StyledCard = styled(Card)`
  width: 100%;
  max-height: 156px;
  border-radius: 16px;
  background-color: ${customPalette.accent.white};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-shadow: none;
  margin: 0 auto;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow:
      0 16px 24px 0 rgba(0, 0, 0, 0.06),
      0 2px 6px 0 rgba(0, 0, 0, 0.04),
      0 0 1px 0 rgba(0, 0, 0, 0.04);
  }

  @media (max-width: 900px) {
    max-height: 600px;
    max-width: 225px;
    margin: 0;
  }
`;

export const ImageComponent = styled.div<{
  isImageLoaded: boolean | undefined;
}>`
  max-width: 256px;
  height: 156px;
  overflow: hidden;
  position: relative;
  transition: height 0.3s ease-in-out;

  & img {
    object-fit: cover;
    width: 256px;
    height: 156px;
    border-radius: 16px 0 0 16px;
    opacity: ${({ isImageLoaded }) => (isImageLoaded ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;

    @media (max-width: 900px) {
      width: 100%;
      height: 156px;
      border-radius: 16px 16px 0 0;
    }
  }

  & .fade-in {
    animation: fadeIn 0.5s ease-in-out forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ContentComponent = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 24px;
  padding-bottom: 15px;
  flex: 1 1 auto;
  @media (max-width: 900px) {
    padding: 16px;
    width: 100%;
    height: 100%;
  }
`;

export const ClickableWrapper = styled.div`
  cursor: pointer;
  width: 100%;
`;
